var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { deserialize } from '../../../utils/serializr/serializr';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
export class SortableStoreStateItem {
    parent;
    sortableItemId;
    droppableId;
    indexInDroppable;
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get overallState() {
        return this.parent;
    }
    get question() {
        return this.overallState.parent;
    }
    static fromSerialized(ser = {}) {
        return deserialize(SortableStoreStateItem, ser);
    }
    static get serializeInfo() {
        return {
            props: {
                sortableItemId: true,
                droppableId: true,
                indexInDroppable: true,
            },
        };
    }
}
__decorate([
    editable()
], SortableStoreStateItem.prototype, "sortableItemId", void 0);
__decorate([
    editable()
], SortableStoreStateItem.prototype, "droppableId", void 0);
__decorate([
    editable()
], SortableStoreStateItem.prototype, "indexInDroppable", void 0);
__decorate([
    memoize
], SortableStoreStateItem, "serializeInfo", null);
